import { render, staticRenderFns } from "./TestVideo.vue?vue&type=template&id=61b731e9&scoped=true&"
import script from "./TestVideo.vue?vue&type=script&lang=js&"
export * from "./TestVideo.vue?vue&type=script&lang=js&"
import style0 from "./TestVideo.vue?vue&type=style&index=0&id=61b731e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b731e9",
  null
  
)

export default component.exports